<div>
  <div class="va-order-form-section-header mat-mdc-card display">
    <div class="product-overview">
      <div class="product-id">
        <va-icon [iconUrl]="data.iconUrl" [iconName]="data.titleText" [diameter]="45"></va-icon>
        <div class="product-id-text">
          <h1 class="product-title">{{ data.titleText }}</h1>
          <span *ngIf="data.subtitleText" class="tagline">
            {{ data.subtitleText }}
          </span>
        </div>
      </div>
      <div class="description" *ngIf="data.descriptionText">
        <span>{{ data.descriptionText }}</span>
      </div>
      <ng-container *ngIf="extraHeaderContent" [ngTemplateOutlet]="extraHeaderContent"></ng-container>
    </div>
  </div>
  <store-dropdown-form-section
    class="va-primary-form-section"
    *ngIf="data.primarySection"
    [titleText]="data.primarySection.titleText"
    [editingHint]="data.primarySection.editingHint"
    [displayAutoDescription]="data.primarySection.displayAutoDescription"
    [descriptionText]="data.primarySection.descriptionText"
    [displayAutoTitle]="data.primarySection.displayAutoTitle"
    [prepopulatedData]="data.primarySection.prepopulatedData"
    [parentForm]="data.parentForm"
    [fields]="data.primarySection.fields"
    [startOpen]="data.primarySection.startOpen"
    [expandable]="data.primarySection.expandable"
    [temporaryStorageKey]="{ businessId: data.businessId, id: data.productId } | buildTemporaryStorageKey"
  ></store-dropdown-form-section>
  <ng-container *ngIf="data.subsections?.length > 0">
    <store-dropdown-form-section
      class="va-secondary-form-section"
      *ngFor="let addon of data.subsections; let i = index"
      [titleText]="addon.titleText"
      [editingHint]="addon.editingHint"
      [displayAutoDescription]="addon.displayAutoDescription"
      [descriptionText]="addon.descriptionText"
      [displayAutoTitle]="addon.displayAutoTitle"
      [prepopulatedData]="addon.prepopulatedData"
      [parentForm]="data.parentForm"
      [fields]="addon.fields"
      [startOpen]="addon.startOpen"
      [expandable]="addon.expandable"
      [temporaryStorageKey]="{ businessId: data.businessId, id: addon.addonId, index: i } | buildTemporaryStorageKey"
    ></store-dropdown-form-section>
  </ng-container>
  <ng-container *ngIf="data?.footerText">
    <mat-card appearance="outlined" class="not-expandable-card">
      <mat-card-content>
        <h1 class="product-title"><b>Additional information</b></h1>
        <div class="footer-text" [innerHTML]="data.footerText"></div>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <div *ngIf="bottomActionsContent" class="bottom-actions-content-container">
    <ng-container *ngIf="bottomActionsContent" [ngTemplateOutlet]="bottomActionsContent"></ng-container>
  </div>
</div>
